import React, {useState, useRef} from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../styled-base/modal';
import BarChartComp from '../../components/barchart';
import {WbEventHandlerMixins, WbDateYearFormat, searchMatchedTextValue} from '../../utils/common';
import Button from '../../styled-base/button';
import TextField from '../../styled-base/input/text';
import {useDispatch} from 'react-redux';
import {addCard} from '../actions/card.actions';
import BoardService from '../services/board.service';

const noop = () => {};

const Row = ({item, isChecked, toggleChkBox}: any) => {
    const leader = typeof item.leader !== "undefined" ? item.leader : "";
    const labelText = item.team
      ? item.team + (leader ? `: ${leader}` : "")
      : leader;

    return (
        <div className="rectbox-row ">
            <div className="rectbox-col">
            <div className="chkbox wbcheckboxcomp" data-testid="chkbox wbcheckboxcomp">
                <input
                type="checkbox"
                className="css-checkbox"
                checked={isChecked}
                value={item.id}
                name="items[]"
                onChange={e =>toggleChkBox(e, item)}
                id={`item-chk-${item.id}`}
                />
                <label
                className="css-label modalParaText"
                htmlFor={`item-chk-${item.id}`}
                />
            </div>
        </div>
        <div className="rectbox-col">
          <BarChartComp count={item.progress} color={item.progress_color} />
        </div>
        <div className="rectbox-col rectbox-col-ws rectbox-col-line">
          <div className="rectbox-title"  data-testid="rectbox-title">
            <span>{WbEventHandlerMixins.unSafeHtml(item.name)}</span>
          </div>
          <div className="rectbox-subtitle">{labelText}</div>
        </div>
        <div
          className="rectbox-col rectbox-col-ws-enddate rectbox-col-line"
          style={{ fontSize: "10px", width: "20%" }}
        >
          <div className="rectbox-ws-enddate">
            {
                (item.target_date && item.target_date > 0) &&
                WbDateYearFormat.getFormateYeardDate(item.target_date)
            }
          </div>
        </div>
      </div>
    )
}


const AddColumnWsModal = ({columnId, data, onClose = noop}: any) => {
    const { t } = useTranslation();
    const wsLists = data.ws || [];
    const dispatch = useDispatch();
    const [lists, searchLists] = useState<any>(wsLists);
    const [selectedItems, setSelectedItems] = useState<any>([]);
    const [text, searchText] = useState<string>();
    const [errorText, setErrorText] = useState<string>();
    const services = new BoardService();
    const openWsRef = useRef(null);

    const addItem = async() => {
        console.log('addItem')
        if (!Array.isArray(selectedItems) || !selectedItems.length) {
            setErrorText(t('Please select atleast one item.'));
        }
        else {
            showLoaderWidget(document.getElementById('content'));
            const response = await services.saveBoardWs({columnId, selWs: selectedItems});
            const {data} = response.data;
            if (Array.isArray(data) && data.length) {
                dispatch(addCard(columnId, data));
            }
            removeLoader();
            onClose();
        }
    }

    const toggleChkBox = (e: any, item: any) => {
        const isChecked = e.target.checked;
        const value = e.target.value;
        if (isChecked) {
            setSelectedItems([...new Set([...selectedItems, value])]);
        }
        else {
            setSelectedItems(selectedItems.filter((v: any) => value != v));
        }
        console.log('toggleChkBox', selectedItems)
    }

    const onSearchText = (e:any) => {
        const value = e.target.value.trim();
        searchText(value);
        if (value) {
            searchLists(wsLists.filter((v: any) => {
                const itemTitle = v.name.toLowerCase();
                const teamName = v.team.toLowerCase();
                return (
                  searchMatchedTextValue(itemTitle, value) ||
                  searchMatchedTextValue(teamName, value)
                );
            }));
        } else {
            searchLists(lists);
        }
    }

    const renderRows = (rows: any) => {
        if (!Array.isArray(rows) || !rows.length) 
            return null;
    
        return rows.map((row: any, index: number) => 
                <Row 
                    key={`ws_${row.id}`}
                    item={row}
                    isChecked={selectedItems.includes(row.id)}
                    toggleChkBox={toggleChkBox}
                />
            )
    }

    const onCreateNewWs = (e: any) => {
        e.preventDefault();
        onClose();
        openWsRef.current.click();
    }

    return (
        <Modal width={500} classes='portal-modal-add-column-ws'>
             <Modal.Header onClose={onClose}>
                <div>{t('Add a Workstream')}</div>
            </Modal.Header>
            <Modal.Content>
                <div className="addWorkstreamBoardPopup">   
                    <div className="createWsText" onClick={e => onCreateNewWs(e)} data-column-id={columnId}>
                        + {t('Create a new workstream board')}
                    </div>
                    <div className="createWsTextPopup" 
                        ref={openWsRef}
                        style={{ display: "none" }} />
                    <div className="wsNormalText">
                        {t('or search for an existing workstream to add to your visual board')}
                    </div>
                    <div className="addwoboitem-text-wrapper">
                        <TextField
                            inputProps = {{
                                name: "s",
                                id: "sbox",
                                placeholder: t("Search by team or workstream"),
                                style: {
                                    border: '1px solid #dce0e3',
                                    height: '37px',
                                    borderRadius: '3px',
                                    padding: '0px 5px 0px 5px',
                                    backgroundColor: 'rgba(204,204,204,.3)'
                                },
                                autoComplete: 'off'
                            }}
                            onChangeText = {onSearchText}
                        />
                        <div className="errormsg" 
                            style={{display: (errorText? 'block': 'none')}}>
                            {errorText}
                        </div>
                    </div>
                    <div className="addwoboitem-wrapper" data-testid="addwoboitem-wrapper">
                        {renderRows(lists)}
                    </div>  
                </div>
            </Modal.Content>
            <Modal.Footer>
                {
                wsLists.length ? 
                    <Button type="primary" onClick={() => addItem()} >
                        {t("Add")}
                    </Button> : ''
                }
            </Modal.Footer>
        </Modal>
    )
}

export default AddColumnWsModal;